import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  Tab,
  Tabs,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "components/SearchBar";
import TableComponent from "components/TableComponent";
import MainContainer from "layout/MainContainer";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isValidInput } from "utils/validations";
import {
  useLazyGetAllSubscriptionQuery,
  useLazyDeleteSubscriptionQuery,
} from "service/subscription";
import { showError, showToast } from "helpers";
import { ConfirmationModal } from "Modals/confirmationModal";
import CustomPagination from "components/Panigation";

const Subscription = () => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subscriptionData, setsubScriptionData] = useState<any[]>([]);
  const [getAllSubscription] = useLazyGetAllSubscriptionQuery();
  const [deleteSubscription] = useLazyDeleteSubscriptionQuery();

  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const columns: GridColDef[] = [
    {
      flex: 0.4,
      minWidth: 100,
      field: "planName",
      headerName: "Plan Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.planName}</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "planDuration",
      headerName: "Duration",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{row?.planDuration} Days</p>
        </div>
      ),
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "planAmount",
      headerName: "Pricing",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>AED {row.planAmount}</p>
        </div>
      ),
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "category",
      headerName: "Vehicle Category",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{row.category?.name?.en}</p>
        </div>
      ),
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "mileageLimit",
      headerName: "Mileage Limit",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{row.mileageLimit} km/day</p>
        </div>
      ),
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "cities",
      headerName: "Allowed Locations",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>
            {row.cities && row.cities.length > 0
              ? row.cities.map((city: any) => city.name.en).join(", ")
              : "Global"}
          </p>
        </div>
      ),
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "paymentMethod",
      headerName: "Payment Methods",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="user_block">
          <p>{row.paymentMethod === 1 ? "Crypto" : "Card"}</p>
        </div>
      ),
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: "isActive",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <Switch
          {...label}
          size="small"
          checked={row.isActive}
          // onChange={() => handleStatusUpdate(row?._id, !row?.isActive)}
        />
      ),
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="table_actions v2">
          {/* <Box>
            <IconButton onClick={() => navigate(`/listing-detail/${row?._id}`)}>
              <img src="/static/images/eye_icon.svg" alt="" />
            </IconButton>
          </Box> */}
          <Box>
            <IconButton
              onClick={() => {
                navigate(
                  `/subscriptions/manage-subscriptions/edit/${row?._id}`
                );
              }}
            >
              <img src="/static/images/edit2_icon.svg" alt="" />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              onClick={() => {
                setSelectedId(row?._id);
                setOpen(true);
              }}
            >
              <img src="/static/images/trash2_icon.svg" alt="" />
            </IconButton>
          </Box>
        </div>
      ),
    },
  ];

  const getSubscriptionApi = async () => {
    setLoading(true);
    try {
      const response = await getAllSubscription({
        page: page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setsubScriptionData(response?.data?.list);
        setCount(response?.data?.pagination?.total);
        setPage(response?.data?.pagination?.page);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  const deleteVehicleApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteSubscription({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        getSubscriptionApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubscriptionApi();
  }, [debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Managing Subscriptions plans</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Subscriptions plans
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button
                  className="btn btn_orange"
                  onClick={() =>
                    navigate("/subscriptions/manage-subscriptions/add")
                  }
                >
                  Add New Subscription
                </Button>
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={subscriptionData}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              getRowId={(ele) => {
                console.log(ele, "elemeent rowid");
                return ele?._id;
              }}
              loading={loading}
              // getRowId={}
            />

            {subscriptionData?.length ? (
              <CustomPagination
                currentPage={page - 1}
                totalPages={Math.ceil(count / 10)}
                count={count}
                pageSize={10}
                onPageChange={(page) => setPage(page + 1)}
              />
            ) : null}
          </div>
        </Box>
        <ConfirmationModal
          text={"Are you sure to delete this Plan?"}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => deleteVehicleApi(selectedId)}
        />
      </div>
    </MainContainer>
  );
};

export default Subscription;
